export const TITLE_TOOLTIP = {
	1: `VC의 기본 정보를 등록할 수 있습니다.`,
	2: `VC의 멤버를 직접 초대하거나 팀원으로 등록된 인원을 불러올 수 있습니다.

<div style="font-weight: 700;font-size: unset;">[멤버 등록 방법]</div>1) 팀원 초대 버튼을 클릭하고 직접 팀원을 입력하여 초대
2) 팀원 초대 버튼을 클릭하고 엑셀 업로드를 통해 팀원을 초대
<div style="font-weight: 700;font-size: unset;">`,
	3: "계획 중인 투자와 투자를 완료한 기업의 정보, 투자금, 회수금, 기업가치를 포트폴리오 형태로 등록 후 관리할 수 있습니다.",
	6: `기업 목록에서 투자 심사 요청을 보낸 기업의 심사 단계 확인과 심사를 진행할 수 있습니다.

<div style="font-weight: 700;font-size: unset;">[요청 방법]</div>1. 투자 - 투자 기업 검색 - 기업 목록으로 이동합니다.
2. 투자 심사 요청을 보낼 기업의 정보를 확인합니다.
3. 투자 심사 심사 요청 버튼을 클릭합니다.
4. 기업에게 보낼 메시지 작성과 심사 항목을 선택합니다.
5. 내부 심사역을 등록합니다.
6. 입력한 내용을 확인 후 심사 요청 버튼을 클릭합니다.`,
	8: `투자 심사를 위해 심사 항목을 직접 설정할 수 있습니다.						

<div style="font-weight: 700;font-size: unset;">[심사 평가 항목 추가]</div>1. 심사 평가 제목을 입력합니다.
2. 카테고리를 등록합니다.
3. 카테고리 별 평가 항목을 등록합니다.
4. 입력한 심사 평가 항목을 최종 확인합니다.
* 각 항목별 가중치를 설정할 수 있습니다.`,
	9: `라운드에 지원한 기업을 심사할 수 있습니다.
라운드에 참여한 총 기업 수와 심사 완료한 기업의 수를 확인할 수 있습니다.`,
	11: `VC가 직접 접수기간, 접수 방법(온라인 질의 작성, 오프라인, 온라인), 장소 등록 등 라운드 정보를 입력하고 등록할 수 있습니다.
단 라운드는 깃발 ST를 이용 중인 기업에게만 정보가 노출되며 비회원의 경우 지원에 제한이 있습니다.
	
<div style="font-weight: 700;font-size: unset;">* 모든 라운드는 심사 설정 클릭 후 심사항목과 심사역 배정을 완료해야 라운드 정보가 깃발 스타트업에 정상적으로 노출됩니다.</div>`,
	12: `라운드 심사를 위해 심사 항목을 직접 설정할 수 있습니다.					

<div style="font-weight: 700;font-size: unset;">[심사 평가 항목 추가]</div>1. 심사 평가 제목을 입력합니다.
2. 카테고리를 등록합니다.
3. 카테고리 별 평가 항목을 등록합니다.
4. 입력한 심사 평가 항목을 최종 확인합니다.
* 각 항목별 가중치를 설정할 수 있습니다.`,
	// 	14: `VC가 직접 신청양식을 만들어 투자 심사를 지원하는 기업의 필요한 정보만 취합해 심사를 진행할 수 있습니다.
	// 공유하기 클릭 시 링크가 생성되어 자사 홈페이지, 외부 투자 플랫폼 등 활용도가 높은 투자 심사 방식입니다.`,
	14: `Apply 지원 기업의 지원 내용을 확인할 수 있습니다.

<div style="font-weight: 700;font-size: unset;">[Apply 설정 항목]</div>1. 지원내용 : 신청양식에 맞춰 기입한 기업 정보를 확인할 수 있습니다.
2. 심사완료 : 심사가 완료되었을 경우 ‘심사완료’ 버튼을 클릭하여 심사를 마칠 수 있습니다.
3. 지원 삭제 : 목록에서 기업을 삭제할 수 있습니다.`,
	15: `Apply 지원 기업의 지원 내용을 확인 후 심사 항목 설정과, 심사역을 배정할 수 있습니다.

<div style="font-weight: 700;font-size: unset;">[Apply 설정 항목]</div>1. 지원내용 : 신청양식에 맞춰 기입한 기업 정보를 확인할 수 있습니다.
2. 심사항목 설정 : 지원 내용을 확인해 심사 항목을 설정할 수 있습니다.
3. 심사역 배정 : 내부 심사역을 선택해 심사역으로 배정할 수 있습니다.
4. 지원 삭제 : 목록에서 기업을 삭제할 수 있습니다.`,
	16: `Apply 심사를 위해 심사 항목을 직접 설정할 수 있습니다.				
	
<div style="font-weight: 700;font-size: unset;">[심사 평가 항목 추가]</div>1. 심사 평가 제목을 입력합니다.
2. 카테고리를 등록합니다.
3. 카테고리 별 평가 항목을 등록합니다.
4. 입력한 심사 평가 항목을 최종 확인합니다.
* 각 항목별 가중치를 설정할 수 있습니다.`,
};
